const cleanText = (value) => {
  if (typeof value !== 'string') return '';
  return value.trim();
};

export const getUserDisplayName = (user) => {
  if (!user) return '';

  const explicitName = cleanText(user?.extra?.full_name)
    || cleanText(user?.full_name)
    || cleanText(user?.name)
    || cleanText(user?.username);

  if (explicitName) return explicitName;

  const composedName = [
    cleanText(user?.firstname),
    cleanText(user?.lastname),
  ].filter(Boolean).join(' ');

  return composedName || cleanText(user?.email);
};

export const getUserInitials = (user) => {
  if (!user) return '';

  const existingInitials = cleanText(user?.extra?.initials);
  if (existingInitials) return existingInitials;

  const nameParts = getUserDisplayName(user)
    .split(/\s+/)
    .filter(Boolean);

  if (nameParts.length >= 2) {
    return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase();
  }

  return nameParts[0]?.slice(0, 2).toUpperCase() || '';
};

export const withSafeUserExtra = (user) => {
  if (!user) return user;

  const fullName = getUserDisplayName(user);
  const initials = getUserInitials(user);

  return {
    ...user,
    extra: {
      ...(user.extra || {}),
      ...(fullName ? { full_name: fullName } : {}),
      ...(initials ? { initials } : {}),
    },
  };
};
